export default "__VITE_ASSET__bc7de9ad__"